import React from 'react';
import Header from './Component/Header/Header';

import './App.css';
import User from './Component/User/User';

function App() {
  return (
    <div>
      <Header></Header>
      <User></User>
    </div>
  );
}

export default App;
